<template>
  <div class="modal-body-2">
    <loading color="green" :active="loading" spinner="bar-fade-scale" />
    <p class="forget-pass-mail">{{text.please_check_your_inbox_or_spam_folder}}</p>
    <form action class="forget-i">
      <div class="mail-input">
        <input
          type="email"
          class="input-modal-login"
          v-model="email"
          name="mail"
          :placeholder="word.email"
        />
        <i class="fas fa-envelope"></i>
      </div>
    </form>
    <button @click.prevent="reset" class="send-code">{{word.send_email}}</button>
    <a href="#" class="come-back">{{word.back}}</a>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loading: false,
      email: null,
      text: window.text,
      word: window.word
    };
  },
  methods: {
    reset() {
      let self = this;
      self.loading = true;
      let data = {
        email: self.email
      };
      axios({
        method: "post",
        url: "/password/email",
        data
      })
        .then(res => {
          if (res.data.ok) {
            self.$toast.success(res.data.msg);
            setTimeout(function() {
              location.href = "/";
              self.loading = false;
            }, 2000);
          } else {
            self.loading = false;
            self.$toast.error(res.data.msg);
          }
        })
        .catch(err => {
          self.loading = false;
          console.log(err.response.data);
          for (const item in err.response.data.errors) {
            self.$toast.error(`${err.response.data.errors[item]}`);
          }
        });
    }
  }
};
</script>
